import type { TScheduleGroup, TScheduleService } from '../schedule';

export const SCHEDULE_SERVICES: Record<
  TScheduleService,
  {
    label: string;
    disabledEdit?: boolean;
    group: TScheduleGroup;
    args?: { label: string; value: string }[];
  }
> = {
  PlanningCalculation: {
    label: 'schedulesPage.services.PlanningCalculation',
    group: 'Planning',
    args: [{ label: 'warehouses', value: 'warehouseIds' }]
  },
  OrderExport: {
    label: 'schedulesPage.services.OrderExport',
    group: 'Export',
    args: [{ label: 'nbHoursBack', value: 'nbHoursBack' }]
  },
  ImportConnector: {
    label: 'schedulesPage.services.ImportConnector',
    group: 'Import',
    disabledEdit: true,
    args: [{ label: 'steps', value: 'steps' }]
  },
  LambdaRunner: {
    label: 'schedulesPage.services.LambdaRunner',
    group: 'Custom',
    args: [
      { label: 'functionName', value: 'functionName' },
      { label: 'payload', value: 'payload' }
    ]
  },
  ForecastProject: { label: 'schedulesPage.services.ForecastProject', group: 'Custom' },
  PlanningSettingRuleEngine: {
    label: 'schedulesPage.services.PlanningSettingRuleEngine',
    group: 'Custom'
  },
  SourceMatchingRuleEngine: {
    label: 'schedulesPage.services.SourceMatchingRuleEngine',
    group: 'Custom'
  },
  DatabaseJob: { label: 'schedulesPage.services.DatabaseJob', group: 'Admin', disabledEdit: true }
};

export const ScheduleServicesOptions = Object.entries(SCHEDULE_SERVICES).map(([key, value]) => ({
  key: key as TScheduleService,
  label: value.label,
  disabled: value.disabledEdit
}));
